export enum Programs {
  eom = 'EOM',
  load = 'LD',
  pallet = 'PLT',
  unload = 'ULD',
  vip = 'VIP',
  delivery = 'DA',
}
